<template lang="html">


  <div class="wrapper margin-menu">

    <section class="intro column-center -noticias">
      <h2>Noticias</h2>
    </section>

    <section class="breadcrumb">
      <nav class="container row-end">
        <router-link to="/">Inicio</router-link>
        <router-link :to="$t('enlaces.noticias')">Noticias</router-link>
      </nav>
    </section>

    <main>

      <div class="filtro container row-start" v-if="!!noticias">
        <input v-model="filter.search" type="text" placeholder="Buscar...">
        <select name="" id="" v-model="filter.cat">
          <option value="">Seleccione categoría</option>
          <option :value="cat.slug" v-for="(cat,key) in categorias">{{cat.name}}</option>
        </select>
      </div>

      <div class="contenedor-noticias container row-start" v-if="!!noticiasFiltered">
        <h2 class="big-title left">Noticias</h2>
        <section class="destacadas">
           <noticia-el v-for="(data,key) in noticiasFiltered.filter(e => e.priority == 1)" :key="key" :data="data"
            :destacada="true"></noticia-el> 
        </section>
        <noticia-el v-for="(data,key) in noticiasFiltered.filter(e => e.priority == 0)" :key="key" :data="data"></noticia-el>
      </div>



    </main>

  </div>

</template>

<script lang="js">


  import noticia from '@/components/parts/noticia-el';


  import { mapGetters } from 'vuex'

  export default {
    name: 'colabora',
    data() {
      return {
        filter: {
          cat: '',
          search: ''
        }
      }
    },
    components: {
      'noticia-el': noticia
    },
    computed: {
      ...mapGetters({
        noticias: 'getNoticias',
        categorias : 'categoriaNoticias'
      }),
      noticiasFiltered() {


        let searchIn = ['title', 'header'];
        let noticias = new Array();

        if (!!this.noticias) {

          if (!!this.filter.cat) {
            noticias = this.noticias.filter(n => (n.categories.some(c => (c.slug == this.filter.cat))));
          }else{
            noticias = this.noticias.slice();
          }

          if (!!this.filter.search) {
            noticias = noticias.filter(n => {
              let include = false;
              searchIn.forEach(s => {
                if (!!!include) {
                  include = ((n[s].toLowerCase().includes(this.filter.search.toLowerCase())));
                }
              })
              return include;
            })
          }
        }

        return noticias;

      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/views/noticias.vue